import ReactDOM from "react-dom";
import App from "./App";
import "typeface-nunito-sans";
import Sentry from "@sentry";

Sentry();

ReactDOM.render(<App />, document.getElementById("root"));
